// extracted by mini-css-extract-plugin
export default {"container":"_3sdwN","iconSuccess":"_2mTR2","success-icon":"giaPy","footerEnterButton":"iX6lx"};